// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"8db559de","353":"101b9a34"}[chunkId] + ".js";
};